import { RotationTreeEnum } from '../../enums/rotationTreeEnum';
import { CargoOperationTypeEnum } from '../../enums/cargoOperationTypeEnum';
import { IRotationNode } from './IRotationNode';
import { PortCall } from './PortCall';
import { BerthCall } from './BerthCall';
import { ReportLocationEnum } from '../../enums/reportLocationEnum';
import { MoveActionMsg } from './ActionMsg';

export class CargoOperation implements IRotationNode {
    constructor(
        cargoOperationId: number | null,
        operationType: CargoOperationTypeEnum | null,
        nominatedWeight: number,
        billOfLadingWeight: number,
        displayWeight: number | null,
        productId: number,
        cargoNumber: string,
        cargoId: number | null,
        imosCargoId: number | null,
        tradeName: string | null,
        chartererName: string,
        isTransshipmentOperation: boolean,
        name: string,
        details: string,
        berthCall: BerthCall | null,
        colorRgb: string,
        nodeStatus: string,
        isDeleted: boolean,
        reportLocation: ReportLocationEnum,
        isMovedTo: boolean,
        delayInputWarningText: string | null,
        firstTimeInPortCall: Date | null,
        demurrageRatePerDay: number | null,
        pumpingRatePerHour: number | null,
        cpDate: Date | null
    ) {
        this.cargoOperationId = cargoOperationId;
        this.cargoOperationType = operationType;
        this.isLoading = operationType === CargoOperationTypeEnum.Loading;
        this.isUnloading = operationType === CargoOperationTypeEnum.Unloading;
        this.nominatedWeight = nominatedWeight;
        this.billOfLadingWeight = billOfLadingWeight;
        this.displayWeight = displayWeight;
        this.productId = productId;
        this.cargoNumber = cargoNumber;
        this.cargoId = cargoId;
        this.imosCargoId = imosCargoId;
        this.tradeName = tradeName;
        this.chartererName = chartererName;
        this.isTransshipmentOperation = isTransshipmentOperation;
        this.type = RotationTreeEnum.CargoOperation;
        this.id = cargoOperationId;
        this.name = name;
        this.details = details;
        this.berthCall = berthCall;
        this.portCall = null;
        this.colorRgb = colorRgb;
        this.dropDownName = name + ' (' + chartererName + ')';
        this.nodeStatus = nodeStatus;
        this.isDeleted = isDeleted;
        this.isMoved = false;
        this.isMovedTo = isMovedTo;
        this.isSelected = false;
        this.isLocked = false;
        this.deletedIconTooltipText = null;
        this.aolDate = null;
        this.reportLocation = reportLocation;
        this.movedFromClicked = false;
        this.actionMsg = new MoveActionMsg(false, null, false, null, null, null);
        this.imosPortFunction = null;
        this.timezoneWarningText = null;
        this.portClusterInitialPortId = null;
        this.portClusterInitialPortName = null;
        this.delayInputWarningText = delayInputWarningText;
        this.firstTimeInPortCall = firstTimeInPortCall;
        this.demurrageRatePerDay = demurrageRatePerDay;
        this.pumpingRatePerHour = pumpingRatePerHour;
        this.cpDate = cpDate;
    }

    cargoOperationId: number | null;
    cargoOperationType: CargoOperationTypeEnum | null;
    isLoading: boolean;
    isUnloading: boolean;
    nominatedWeight: number;
    billOfLadingWeight: number;
    displayWeight: number | null;
    productId: number;
    cargoNumber: string;
    cargoId: number | null;
    imosCargoId: number | null;
    tradeName: string | null;
    chartererName: string;
    isTransshipmentOperation: boolean;
    type: RotationTreeEnum;
    id: number | null;
    name: string;
    details: string;
    portCall: PortCall | null;
    berthCall: BerthCall | null;
    isSelected: boolean;
    colorRgb: string;
    dropDownName: string;
    nodeStatus: string;
    isMoved: boolean;
    isMovedTo: boolean;
    isDeleted: boolean;
    actionMsg: MoveActionMsg;
    isLocked: boolean;
    deletedIconTooltipText: string | null;
    aolDate: Date | null;
    reportLocation: ReportLocationEnum;
    movedFromClicked: boolean;
    imosPortFunction: string | null;
    timezoneWarningText: string | null;
    portClusterInitialPortId: number | null;
    portClusterInitialPortName: string | null;
    delayInputWarningText: string | null;
    firstTimeInPortCall: Date | null;
    demurrageRatePerDay?: number | null;
    pumpingRatePerHour?: number | null;
    cpDate?: Date | null;
}
